import {space} from '@convincely/utils/lib/strings.js';

/**
 * @param {string} string
 * @return {string}
 */
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function capitalizeFirstLetterOfEveryWord(string) {
  return string.split(space).map(capitalizeFirstLetter).join(space);
}
